export default __webpack_public_path__ + "static/media/img-0308-brazil-half-face.c6769454.png";